import axiosInstance from '../../axios-config';

const patientApi = '/api/patients';

export const getPatientAddress = (patientId) => axiosInstance.get(`${patientApi}/${patientId}/address`);

export const getPatient = (patientId) => axiosInstance.get(`${patientApi}/${patientId}`);
